import esriLoader from 'esri-loader'
import mapConfig from '@/lib/mapUrl'
import store from "@/store/index";
import {
  getRowCol,
  getCoordByRowCol,
  getVectorCollection,
  createGSPTile,
  getDefaultSymbol,
  applyTaskLayerFeature,
  initBaseMap,
  initVetorLayer,
  identifyTask,
  extentChange,
  scaleHandleChange,
  dragChange,
  tiledQueryTask,
  handleOffsetEvent,
  pickUpEvent,
  addTileData,
  getAllDataFromServer,
  getChangedData,
  initVectorTree,
  dblCilckEvent,
  getVetorLayerNode,
  createCanvas,
  clearCanvasFromSelect,
  settingPickedToSelected,
  addDataToSelectedData,
  getType,
  getmapDocId,
  convertLngLat,
  stopDrawText,
  RepairGeo,
  clearCancleToken,
  mouseMoveEvent,
  addRegionalOnline,
  addEMapLayer
} from "@/assets/js/common";
import commonB from "@/assets/js/common-addition.js"
 
var esriModule = null;
esriLoader.loadCss(mapConfig.cssUrl)
window.appConfig = null
window.map = null
window.toolManage = null
import gspTileLayer from '@/assets/js/customModules/GSPTileLayer'

var baseMapUrl = "http://" + window.location.hostname + ":8080/"
const mapObj = {
  /**
   * 初始化地图
   */
   async initMap(baseMapLayer) {
    var GSPTileLayer = await gspTileLayer();
    esriLoader
      .loadModules([
        "esri/map",
        "esri/layers/WebTiledLayer",
        "esri/layers/ArcGISTiledMapServiceLayer",
        "esri/layers/GraphicsLayer",
        "esri/geometry/Point",
        "esri/geometry/Polygon",
        "esri/geometry/Polyline",
        "esri/geometry/Extent",
        "esri/SpatialReference",
        "esri/toolbars/draw",
        "esri/graphic",
        "esri/symbols/SimpleLineSymbol",
        "esri/symbols/SimpleFillSymbol",
        "esri/symbols/SimpleMarkerSymbol",
        "esri/symbols/PictureFillSymbol",
        "esri/symbols/TextSymbol",
        "esri/symbols/Font",
        "esri/toolbars/edit",
        "esri/geometry/geometryEngine",
        "esri/Color",
        "esri/layers/TileInfo",
        "esri/geometry/webMercatorUtils",
        "esri/layers/FeatureLayer",
        "esri/renderers/SimpleRenderer",
        "esri/renderers/UniqueValueRenderer",
        "esri/symbols/PictureMarkerSymbol",
        "esri/geometry/geodesicUtils",
        "esri/dijit/Scalebar",
        "esri/renderers/ClassBreaksRenderer",
        "esri/renderers/HeatmapRenderer",
        "esri/layers/ArcGISDynamicMapServiceLayer",
        "esri/tasks/IdentifyTask",
        "esri/tasks/IdentifyParameters",
        "esri/geometry/ScreenPoint",
        "esri/geometry/projection",
        "dojo/_base/lang",
        "dojo/dom",
        "dojo/on",
        "dojo/domReady!"
      ], {
        url: mapConfig.gisUrl
      })
      .then(([
        Map,
        WebTiledLayer,
        ArcGISTiledMapServiceLayer,
        GraphicsLayer,
        Point,
        Polygon,
        Polyline,
        Extent,
        SpatialReference,
        Draw,
        Graphic,
        SimpleLineSymbol,
        SimpleFillSymbol,
        SimpleMarkerSymbol,
        PictureFillSymbol,
        TextSymbol,
        Font,
        Edit,
        geometryEngine,
        Color,
        TileInfo,
        webMercatorUtils,
        FeatureLayer,
        SimpleRenderer,
        UniqueValueRenderer,
        PictureMarkerSymbol,
        geodesicUtils,
        Scalebar,
        ClassBreaksRenderer,
        HeatmapRenderer,
        ArcGISDynamicMapServiceLayer,
        IdentifyTask,
        IdentifyParameters,
        ScreenPoint,
        projection,
        lang,
        dom,
        on
      ]) => {
        let that = this

        esriModule = {
          WebTiledLayer,
          ArcGISTiledMapServiceLayer,
          Draw,
          Color,
          Graphic,
          GraphicsLayer,
          Point,
          Polyline,
          Polygon,
          FeatureLayer,
          SimpleMarkerSymbol,
          SimpleLineSymbol,
          SimpleFillSymbol,
          PictureMarkerSymbol,
          PictureFillSymbol,
          SimpleRenderer,
          Font,
          TextSymbol,
          geometryEngine,
          geodesicUtils,
          UniqueValueRenderer,
          Extent,           
          GSPTileLayer,
          webMercatorUtils,
          SpatialReference,
          Scalebar,
          ClassBreaksRenderer,      
          ArcGISDynamicMapServiceLayer,
          IdentifyTask,
          IdentifyParameters,
          ScreenPoint,
          projection
      };


        store.commit("setEsriModule", esriModule);
        map = new Map("mapView", {
          isClickRecenter: false,
          isDoubleClickZoom: false,
          isKeyboardNavigation: false,
          isZoomSlider:false,
          logo: true
        });

        // 加载底图图层
        if(baseMapLayer.length > 0) {
          // 排序
          let sortData = baseMapLayer.sort((a, b) => {return a.index - b.index})
          sortData.forEach(element => {
            if(element.baseMapUrl) {
              let baselayer = createGSPTile(element.baseMapUrl);
              baselayer.id = String(element.id);
              map.addLayer(baselayer)
            }
          });
        }else {
            let baselayer = createGSPTile("https://server.gispai.com/#/services/rest/info/天地图/影像图2000/registrationservice");
            baselayer.id = "baseLayer_bId";
            map.addLayer(baselayer)
        }


        // let baselayer = createGSPTile("https://server.gispai.com/#/services/rest/info/天地图/影像图2000/registrationservice");
        // baselayer.id = "baseLayer_bId";
        // map.addLayer(baselayer)

        // let baselayer2 = createGSPTile("https://server.gispai.com/#/services/rest/info/天地图/yjIMG/mapservice");
        // baselayer2.id = "baseLayer_bId2";
        // map.addLayer(baselayer2)

        // let baselayer3 = createGSPTile("https://server.gispai.com/#/services/rest/info/天地图/路网2000/registrationservice");
        // baselayer3.id = "baseLayer_bId3";
        // map.addLayer(baselayer3)

        // let baselayer4 = createGSPTile("https://server.gispai.com/#/services/rest/info/其它/xunhuren/mapservice");
        // baselayer4.id = "baseLayer_bId4";
        // map.addLayer(baselayer4)

        let point = new esriModule.Point(
          106.4862,
          23.9325,
			    map.spatialReference
			  );
			  map.centerAndZoom(point, 10);

        map.on('click', (evt) => {
          // if (evt.graphic != undefined && evt.graphic.attributes && evt.graphic.attributes.id != undefined) {
            // store.commit('set_patrolPointId', -1)
          // }
        })
        map.on("mouse-move", function (evt) {
          
          if (evt.graphic != undefined && evt.graphic.attributes && evt.graphic.attributes.id != undefined) {
            store.commit('set_patrolPointId', evt.graphic.attributes.id)
            store.commit('set_mousePosition',{ top: evt.clientY, left: evt.clientX})
          }else {
            store.commit('set_patrolPointId', -1)
          }
        })

        let lineLayer = new esriModule.GraphicsLayer({
          id: "youjiang_scope",
        });
        var myLine ={geometry:{"paths":require("@/static/youjiang_scope.json"),
          "spatialReference":{"wkid":4326}},
          "symbol":{"color":[255,0,0,255],"width":2,"type":"esriSLS","style":"esriSLSSolid"}};
        var gra= new Graphic(myLine);
        lineLayer.add(gra)
        map.addLayer(lineLayer)

      })
      /**
       * 捕获错误
       */
      .catch(err => {
        console.error(err)
      })
  }
}

export default mapObj
